import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import SvgIcon from './icons/SvgIcon';
import { IconAxel } from '../resources/images';
import Text, { TextComponentProps } from './text';

interface NameboardDetailsProps {
    meetingPoint: string;
    pancarte?: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const NameboardDetails: FC<NameboardDetailsProps> = ({ meetingPoint, pancarte }) => {
    const classes = useStyles();

    if (!meetingPoint || meetingPoint.trim() === '') {
        return null; // Return null if meetingPoint is empty or undefined
    }

    const meetingPointColor: TextComponentProps['customColor'] = 'black';

    return (
        <>
            <span className={classes.meetingPointPointer} />
            <div className={classes.meetingPointContainer}>
                <SvgIcon icon={IconAxel.Localisation} size="mediumSmall" fix="18" />
                <Text.ShortRegularText14
                    customColor={meetingPointColor}
                    text={meetingPoint}
                    // text={pancarte ? stringsRes.booking.pancarteRdv : meetingPoint}
                />
            </div>
        </>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        meetingPointContainer: {
            padding: '20px 16px',
            backgroundColor: theme.palette.colors.border,
            gap: 12,
            borderRadius: 4,
            display: 'flex',
        },
        meetingPointPointer: {
            display: 'block',
            backgroundColor: theme.palette.colors.border,
            width: 18,
            height: 18,
            borderRadius: '2px 0px 0px 0px',
            transform: 'rotate(45deg)',
            position: 'relative',
            top: 11,
            left: 14,
        },
    }),
);

export default NameboardDetails;
